import React from 'react'

export class ErrorBoundary extends React.Component {
  state = {}
  static getDerivedStateFromProps (props, oldState) {
    /* if (oldState.error && props.children && oldState.childrenProps !== props.children.props)
     *   return {
       childrenProps: props.children.props,
       error: null,
       errorInfo: null
     *   } */
    return null
  }

  componentDidCatch (error, errorInfo) {
    this.setState({
      error,
      errorInfo
    })
  }

  resetError = () => {
    this.setState({ error: null, errorInfo: null })
  }

  render () {
    if (this.state.errorInfo) {
      return (
        <div className='error-boundary' style={{ pointerEvents: 'auto' }}>
          <div>
            <button onClick={this.resetError}>Reload</button>
            <h4>{`Error in ${this.props.name}`}</h4>
          </div>
          <code style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
          </code>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.errorInfo.componentStack}
          </details>
        </div>
      )
    }

    return this.props.children
  }
}

const tryRender = (Component, name) => {
  let Comp

  if (typeof Component === 'object' && typeof Component.message === 'string') {
    const ErrorComp = () => <pre>{Component.message}</pre>
    Comp = ErrorComp
  } else {
    Comp = Component || (() => null)
  }

  const TryRender = (props) => (
    <ErrorBoundary name={name}>
      <Comp {...props} />
    </ErrorBoundary>
  )
  return TryRender
}

export default tryRender
